export default __webpack_public_path__ + "static/media/project.828a2077.svg";